import { useState } from "react";
import { isWebStorageAvailable, WebStorageKind } from ".";

export const useWebStorageAvailability = (
  storageKind: WebStorageKind
): boolean => {
  const [isAvailable] = useState(() => isWebStorageAvailable(storageKind));

  return isAvailable;
};
